"use client";

import React from "react";
import { ArrowRight, PhoneCall, ShieldCheck, Sparkles } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-24">
      {/* Decorative background grid pattern */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] [background-image:radial-gradient(hsl(var(--foreground))_1px,transparent_1px)] [background-size:24px_24px]" aria-hidden="true" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-3xl bg-primary px-6 py-12 text-primary-foreground shadow-2xl sm:px-12 md:py-16 lg:px-16">
          {/* Subtle industrial visual elements */}
          <div className="pointer-events-none absolute -right-20 -top-20 size-80 rounded-full bg-secondary/20 blur-3xl" aria-hidden="true" />
          <div className="pointer-events-none absolute -bottom-20 -left-20 size-80 rounded-full bg-secondary/10 blur-3xl" aria-hidden="true" />

          <div className="relative mx-auto max-w-4xl text-center">
            {/* Tagline */}
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-primary-foreground/90 backdrop-blur-xs">
              <Sparkles className="size-3.5 text-secondary-foreground" />
              <span>Engenharia e Pulverização Industrial</span>
            </div>

            {/* Headline */}
            <h2 className="mt-6 text-2xl font-bold tracking-tight text-primary-foreground sm:text-3xl md:text-4xl lg:text-5xl font-default">
              Encontre a solução de pulverização ideal para o seu processo
            </h2>

            {/* Supporting line */}
            <p className="mx-auto mt-4 max-w-2xl text-base text-primary-foreground/80 sm:text-lg">
              Fale com a nossa equipa técnica especializada e descubra como
              otimizar a eficiência, reduzir o desperdício e aumentar a
              rentabilidade na sua indústria.
            </p>

            {/* Call to action button */}
            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
              <Button asChild size="lg" className="group h-12 w-full rounded-xl bg-secondary px-8 text-base font-semibold text-secondary-foreground shadow-lg transition-[transform,background-color,box-shadow] hover:bg-secondary/90 hover:shadow-xl sm:w-auto">
                <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 w-full rounded-xl border-primary-foreground/20 bg-primary-foreground/10 px-6 text-base font-medium text-primary-foreground backdrop-blur-xs transition-[background-color,border-color] hover:border-primary-foreground/40 hover:bg-primary-foreground/20 hover:text-primary-foreground sm:w-auto">
                <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                  <PhoneCall className="size-4" />
                  <span>Falar com especialista</span>
                </Link>
              </Button>
            </div>

            {/* Trust highlights */}
            <div className="mt-10 border-t border-primary-foreground/15 pt-6">
              <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-primary-foreground/75 sm:text-sm">
                <div className="inline-flex items-center gap-2">
                  <ShieldCheck className="size-4 text-secondary-foreground" />
                  <span>Representante exclusivo Spraying Systems Co. desde 1993</span>
                </div>
                <div className="hidden size-1 rounded-full bg-primary-foreground/40 sm:block" />
                <span>Apoio e dimensionamento técnico personalizado</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}